import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  hero: {
    textAlign: 'center',
    padding: theme.spacing(4, 2, 3),
    marginBottom: theme.spacing(2),
  },
  heroTitle: {
    fontSize: 26,
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  heroSubtitle: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2.5),
    margin: '0 auto',
  },
  searchRow: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(1.5),
  },
  searchField: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
  },
}))

export default useStyles
